export default __webpack_public_path__ + "static/media/logo2.8195d323.png";